// extracted by mini-css-extract-plugin
export default {"heading":"lw-z","corrected":"mw-z","redirectVerbiageContainer":"nw-z","redirectVerbiageText":"ow-z"};